import { GlobalValue } from '../GlobalValue/GlobalValue';

type CustomInstructionsCellProps = {
  instructions: string | null;
};

export const CustomInstructionsCell = ({ instructions }: CustomInstructionsCellProps) => {
  if (!instructions) {
    return <GlobalValue />;
  }

  return <span className="truncate text-gray-700">{instructions}</span>;
};
